export default "__VITE_ASSET__tI8aEEOy__"